<div class="ach-info" *ngIf="flashPaymentService.controller.isACH">
    <div class="summary-container">
      <div class="summary-title-info">
        <div class="summary-title">Pago de Factura</div>
        <div class="summary-title">{{flashPaymentService.controller.today.toString().substring(0,10) | date: 'MM/dd/yyyy'}}</div>
      </div>

      <div class="summary-items">
        <div class="title-item">N&uacute;mero de Orden</div>
        <div class="value-item">{{flashPaymentService.controller.numberOfOrder }}</div>
      </div>

      <div class="summary-items">
        <div class="title-item">N&uacute;mero de Cuenta</div>
        <div class="value-item">{{flashPaymentService.controller.accountNumber }}</div>
      </div>

      <div class="summary-items">
        <div class="title-item">Banco</div>
        <div class="value-item">{{flashPaymentService.controller.Bank }}</div>
      </div>

      <div class="summary-items">
        <div class="title-item">Cuenta de Banco</div>
        <div class="value-item">Ahorro personal ****1234 {{flashPaymentService.controller.BankAccount }}</div>
      </div>

      <div class="summary-items">
        <div class="title-item">N&uacute;mero de Ruta</div>
        <div class="value-item">{{flashPaymentService.controller.routeNumber }}</div>
      </div>
      <div class="line-decorator-strong"></div>
      <div class="action-container"><strong>Total a pagar</strong></div>
      <div class="action-container">
        <div class="amount-to-pay">{{flashPaymentService.controller.operationAmount | currency}}</div>
      </div>
    </div>

    <div class="line-decorator"></div>

    <div class="flash-form-container-title">
      Autorizaci&oacute;n para D&eacute;bito Directo
    </div>
    <div class="message-confirmation">
      Yo, <strong>Rosa Rivera</strong>, por la presente
      <strong>aotorizo a Miclaro PR</strong>, a iniciar una transaccion de
      debito a mi cuenta de ahorro personal ***** {{flashPaymentService.controller.BankAccount }} en BANCO POPULAR por la
      cantidad de
      <strong> {{flashPaymentService.controller.operationAmount }}</strong>
    </div>
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        value=""
        [(ngModel)]="flashPaymentService.controller.AccordingToTheOperation"
        id="AccordingToTheOperation"
        name="AccordingToTheOperation"
      />
      <label class="form-check-label" for="AccordingToTheOperation">
        <strong>Estoy de acuerdo</strong>
      </label>
    </div>
    <div class="line-decorator"></div>
    <div class="action-container">
      <button
      (click)="flashPaymentService.achPayment()"
      class="btn btn-danger action-btn" >
        &nbsp; &nbsp; &nbsp; Pagar &nbsp; &nbsp; &nbsp;
      </button>
    </div>
  </div>
